<template>
    <!-- Footer Start -->
    <footer class="shadow dark:shadow-gray-700 bg-white dark:bg-slate-900 px-6 py-4">
        <div class="container-fluid">
            <div class="grid sm:grid-cols-1 md:grid-cols-2">
                <div class="sm:text-start text-center mx-md-2">
                    <p class="mb-0 text-slate-400 text-center">©
                        {{date}} أساكيب، تم تطويره <i class="mdi mdi-heart text-red-600"></i> بواسطة <a
                            href="https://system.edunezam.com" target="_blank" class="text-reset">إديو نظام</a>.
                    </p>
                </div><!--end col-->
                <!-- <div class="text-center">
                    {{ formatted }}
                </div> -->
            </div><!--end grid-->
        </div><!--end container-->
    </footer><!--end footer-->
    <!-- End -->
</template>

<script setup>
// import { useDateFormat, useNow } from '@vueuse/core'
// const formatted = useDateFormat(useNow(), 'YYYY-MM-DD HH:mm:ss')

const date = new Date().getFullYear()

</script>

<style lang="scss" scoped></style>